import { render } from "./CheckoutSidebar.vue?vue&type=template&id=57878188&scoped=true"
import script from "./CheckoutSidebar.vue?vue&type=script&lang=js"
export * from "./CheckoutSidebar.vue?vue&type=script&lang=js"

import "./CheckoutSidebar.vue?vue&type=style&index=0&id=57878188&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57878188"]])

export default __exports__